import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=4b4c77b2&"
var script = {}
import style0 from "./IconList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4c77b2')) {
      api.createRecord('4b4c77b2', component.options)
    } else {
      api.reload('4b4c77b2', component.options)
    }
    module.hot.accept("./IconList.vue?vue&type=template&id=4b4c77b2&", function () {
      api.rerender('4b4c77b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconList.vue"
export default component.exports